import { MODAL_CARGA_DDJJ } from '../constants/modal-carga-ddjj.js'

// Los textos que no se pasan por props toman el valor de la carga del médico (PBI 81147).
// `template` se combina aparte para poder cambiar, por ejemplo, sólo el nombre del archivo.
export function combinarTextosDdjj(textos = {}) {
  return {
    ...MODAL_CARGA_DDJJ,
    ...textos,
    template: { ...MODAL_CARGA_DDJJ.template, ...textos.template },
  }
}
